import { useLocation } from 'react-router-dom';
import type { SchedulerRole } from '@lucid/test-drive-scheduler';
import { buildLocalePath } from './useLocaleNavigate';
import { useContentfulLocale } from './useContentfulLocale';
import { useSchedulerRole } from './useSchedulerRole';

export type SchedulerHostProps = {
  luppBaseUrl: string;
  contentful: { graphqlUrl: string; accessToken: string; locale: string };
  role?: SchedulerRole;
  testDriveBookingsPath: string;
};

/**
 * Builds the host props shared by every `@lucid/test-drive-scheduler` entry point.
 * @hook
 */
export const useSchedulerHostProps = (): SchedulerHostProps => {
  const role = useSchedulerRole();
  const locale = useContentfulLocale();
  const { pathname } = useLocation();

  return {
    luppBaseUrl: import.meta.env.VITE_LUPP_BASE_URL ?? '',
    contentful: {
      graphqlUrl: import.meta.env.VITE_CONTENTFUL_GRAPHQL_URL ?? '',
      accessToken: import.meta.env.VITE_CONTENTFUL_ACCESS_TOKEN ?? '',
      locale,
    },
    role,
    testDriveBookingsPath: buildLocalePath(pathname, '/prospect-desk/test-drive-bookings'),
  };
};
